module.exports = __webpack_public_path__ + "static/media/logo.41f49ae1.svg";